import { Anchor, Box, Loader } from '@mantine/core';
import { ReactComponent as ArrowSvg } from 'assets/img/arrowOpenBlock.svg';
import { Avatar } from 'components/Avatar';
import { AvatarMobile } from 'components/AvatarMobile';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { ModalContract } from 'components/ModalContract';
import { ModalLogout } from 'components/ModalLogout';
import { ModalProfile } from 'components/ModalProfile';
import { Nothing } from 'components/Nothing';
import { TabProfile } from 'components/TabProfile';
import { Title } from 'components/Title';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as AlertIcon } from './img/alert.svg';
import type { RootState } from 'redux/store';
import { Button } from 'ui/Button';
import { InfoBlock } from 'ui/InfoBlock';
import { PriceItem } from 'ui/PriceItem';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import { getFormatPhone } from 'utils/getFotmatPhone';
import { ReactComponent as DocSvg } from './img/iconDocument.svg';
import check from './img/iconDone.svg';
import { ReactComponent as IconDone2 } from './img/iconDone2.svg';
import { ReactComponent as IconCancel } from './img/iconCancel.svg';
import { ReactComponent as IconDone } from './img/iconDone.svg';
import { ReactComponent as IconExit } from './img/iconExit.svg';
import { ReactComponent as PaymentSvg } from './img/iconPayMent.svg';
import { ReactComponent as PdfSvg } from './img/pdf.svg';
import styles from './Profile.module.scss';
import { Security } from './Security';
import { Helmet } from 'react-helmet';
import { CompanySelect } from 'components/CompanySelect/CompanySelect';
import { GeneralNotification } from 'components/GeneralNotification/GeneralNotification';
import { Modal } from 'components/Modal';
import modalStyles from './Modal.module.scss';
import { SuccessErrorInfo } from 'components/SuccessErrorInfo';
import {
  useGetInfoUserQuery,
  useGetProfileQuery,
  useGetTabsQuery,
} from 'redux/Api/profileApi/ProfileApi';
import { TextWithTooltip } from 'hooks/TextWithTooltip';
import { useMediaQuery } from '@mantine/hooks';
import { Layout } from 'features/Layouts/Layouts';

interface customerType {
  inn: string;
  jur_address: string;
  jur_name: string;
}

export interface SuggestionsConnectType {
  can_manage_orders: boolean;
  customer: customerType;
  id: number;
  orders_limit: number | null;
}

export const Profile = () => {
  const location = useLocation();

  const { data: tabsData, isLoading: tabsLoading, error: tabsError } = useGetTabsQuery();
  const { data, isLoading, error, refetch: refetchProfile } = useGetProfileQuery();
  const { data: userData } = useGetInfoUserQuery();
  const { name } = useSelector((state: RootState) => state.authSlice);
  const [showModalProfile, setShowModalProfile] = useState(false);
  const [showModalContract, setShowModalContract] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [openContent, setOpenContent] = useState(false);
  const [timer, setTimer] = useState(60);
  const [startTimer, setStartTimer] = useState(false);
  const [suggestionsConnect, setSuggestionsConnect] = useState([]);
  const [showSuggestionsConnect, setShowSuggestionsConnect] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [invitationAction, setInvitationAction] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState<SuggestionsConnectType | null>(
    null,
  );
  const [isLoadingApproved, setIsLoadindApproved] = useState(false);
  const [isLoadingCancel, setIsLoadindCancel] = useState(false);
  const isSecurityPage = location.pathname === '/profile/security';
  const screen = useMediaQuery('(width <= 1185px)');
  const [openNav, setOpenNav] = useState<boolean | undefined>(false);

  useLayoutEffect(() => {
    const fetchInvitations = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/user/invitations`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
          },
        );

        const data = await response.json();
        setSuggestionsConnect(data);
      } catch {
        //
      }
    };
    fetchInvitations();
  }, []);

  useEffect(() => {
    if (startTimer) {
      const timeout = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearTimeout(timeout);
    }
  }, [startTimer]);

  useEffect(() => {
    if (timer === 0) {
      setStartTimer(false);
      setTimer(60);
    }
  }, [timer]);

  const showSuggestionsConnectHandle = (customer: SuggestionsConnectType) => {
    setSelectedCustomer(customer);
    setShowSuggestionsConnect(true);
  };

  const respondingInvitationHandle = async (id: number, action: string) => {
    action === 'accept' ? setIsLoadindApproved(true) : setIsLoadindCancel(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/user/invitations/${id}?action=${action}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        },
      );

      const data = await response.json();

      if (data) {
        setInvitationAction(action);
        setShowNotification(true);
      }
      const suggestionsConnectFiltred = suggestionsConnect.filter(
        (el: SuggestionsConnectType) => {
          return el.id !== id;
        },
      );
      setSuggestionsConnect(suggestionsConnectFiltred);
      setShowSuggestionsConnect(false);
      if (action === 'accept') {
        await refetchProfile();
      }
    } catch {
      //
    } finally {
      setIsLoadindApproved(false);
      setIsLoadindCancel(false);
    }
  };

  const arrPayment = [
    {
      sum: data?.beneficiary?.virtual_account?.main_account_cash,
      type: 'standard',
    },
  ];

  const Balance = () => {
    return (
      <>
        <div className={styles.root_price}>
          <div
            onClick={() => setOpenContent(!openContent)}
            className={styles.root_info_blockPrice}>
            <div className={styles.root_info_blockPrice_info}>
              <PaymentSvg />
              <div>
                <p>Баланс, ₽</p>
                <b>
                  {data?.beneficiary?.virtual_account?.total_cash
                    ? addSpaceNumber(data?.beneficiary?.virtual_account?.total_cash)
                    : '0'}{' '}
                </b>
              </div>
            </div>
            <div
              className={styles.root_info_blockPrice_icon}
              style={openContent ? { transform: 'rotate(180deg)' } : {}}>
              <ArrowSvg />
            </div>
          </div>

          {openContent && (
            <div className={styles.cashBlock}>
              {arrPayment.map((elem, i) => (
                <PriceItem
                  hold={data?.beneficiary?.virtual_account?.main_account_hold}
                  key={i}
                  type={elem.type}
                  cash={elem?.sum}
                />
              ))}
            </div>
          )}
        </div>
      </>
    );
  };

  return (
    <Layout setOpenNav={setOpenNav}>
      <Helmet>
        <title>Профиль</title>
      </Helmet>
      {tabsLoading || isLoading || error || tabsError ? (
        <div className={styles.root}>
          {error || tabsError ? <Nothing /> : <LoadingSkeleton mt />}
        </div>
      ) : (
        <>
          <div className={styles.custom}>
            {suggestionsConnect.length
              ? suggestionsConnect.map((el: SuggestionsConnectType) => (
                  <GeneralNotification
                    key={el.id}
                    data={{
                      title: 'Приглашение',
                      body: `Компания ${el.customer.jur_name} приглашает вас к сотрудничеству`,
                      text_button: 'Открыть приглашение',
                    }}
                    onClick={() => showSuggestionsConnectHandle(el)}
                    styles={'profile'}
                  />
                ))
              : null}
          </div>
          {showSuggestionsConnect && (
            <Modal setOpen={setShowSuggestionsConnect}>
              <div className={modalStyles.root}>
                <Title
                  className={modalStyles.title}
                  title='Приглашение к сотрудничеству'
                />
                {selectedCustomer?.can_manage_orders ? (
                  <span className={modalStyles.textStatus_Done}>
                    <IconDone2 /> С правом подписания договоров, создавать и завершать
                    заказы
                  </span>
                ) : (
                  <span className={modalStyles.textStatus_Cancel}>
                    <AlertIcon width={'16px'} height={'16px'} /> Без права подписания
                    договоров, создания и завершения заказов
                  </span>
                )}
                <div className={modalStyles.test}>
                  <p className={modalStyles.details}>Компания</p>
                  <p className={modalStyles.textModal}>
                    {selectedCustomer?.customer.jur_name}
                  </p>
                </div>
                <div className={modalStyles.test}>
                  <p className={modalStyles.details}>ИНН</p>
                  <p className={modalStyles.textModal}>
                    {selectedCustomer?.customer.inn}
                  </p>
                </div>
                <div className={modalStyles.test}>
                  <p className={modalStyles.details}>Юридический адрес</p>
                  <p className={modalStyles.textModal}>
                    {selectedCustomer?.customer.jur_address}
                  </p>
                </div>
                <div className={modalStyles.test}>
                  <p className={modalStyles.details}>Лимит на месяц</p>
                  <p className={modalStyles.textModal}>
                    {selectedCustomer?.orders_limit}
                  </p>
                </div>
                <div className={modalStyles.buttons}>
                  <Button
                    onClick={() =>
                      respondingInvitationHandle(Number(selectedCustomer?.id), 'reject')
                    }
                    className={modalStyles.button_cancel}
                    theme='outline'>
                    <span className={styles.btn_children}>
                      {isLoadingCancel ? (
                        <Loader size='xs' color='#002cfb' />
                      ) : (
                        <IconCancel />
                      )}
                      Отказаться
                    </span>
                  </Button>
                  <Button
                    onClick={() =>
                      respondingInvitationHandle(Number(selectedCustomer?.id), 'accept')
                    }
                    className={modalStyles.button_accept}
                    src={check}
                    theme='filed'>
                    <span className={styles.btn_children}>
                      {isLoadingApproved ? (
                        <Loader size='xs' color='white' />
                      ) : (
                        <IconDone />
                      )}
                      <span className={modalStyles.btn_accept_full}>
                        Принять приглашение
                      </span>
                      <span className={modalStyles.btn_accept_short}>Принять</span>
                    </span>
                  </Button>
                </div>
              </div>
            </Modal>
          )}
          {invitationAction === 'accept'
            ? showNotification && (
                <SuccessErrorInfo
                  type='success'
                  text='Приглашение к сотрудничеству принято'
                  handleClose={() => setShowNotification(false)}
                />
              )
            : showNotification && (
                <SuccessErrorInfo
                  type='error'
                  text='Приглашение к сотрудничеству отклонено'
                  handleClose={() => setShowNotification(false)}
                />
              )}
          <div className={styles.profile}>
            <div className={styles.profile_top}>
              <div className={styles.profile_top__user}>
                <Box visibleFrom='sm'>
                  <Avatar
                    avatar={userData?.avatar ?? null}
                    id={1}
                    statusActive=''
                    name={name}
                    height={'64px'}
                    width={'64px'}
                  />
                </Box>
                <Box hiddenFrom='sm'>
                  <AvatarMobile avatar={userData?.avatar ?? null} size={40} name={name} />
                </Box>
                <div className={styles.profile_top__user__wrapper}>
                  <p className={styles.profile_top__user__name}>{userData?.fio}</p>
                  <div className={styles.profile_top__user__contacts}>
                    <span>{getFormatPhone(userData?.phone)}</span>
                    <span>{userData?.email}</span>
                  </div>
                </div>
              </div>

              <Button
                theme='link'
                className={styles.gray}
                onClick={() => setShowLogoutModal(true)}>
                <div>
                  <div className={styles.exitBox}>
                    Выйти
                    <IconExit
                      onClick={() => setShowLogoutModal(true)}
                      width={24}
                      height={24}
                    />
                  </div>
                </div>
              </Button>
            </div>

            <div className={styles.profile_bottom}>
              {data?.beneficiary?.document?.is_signed && (
                <Link
                  to='/profile/security'
                  className={isSecurityPage ? styles.active : ''}>
                  Безопасность
                </Link>
              )}
              <a href='https://skilla.ru/legal' target='_blank' rel='noreferrer'>
                Пользовательское соглашение
              </a>
            </div>
          </div>
          {!data?.beneficiary?.document?.is_signed && (
            <div className={styles.documents}>
              <div className={styles.documents_title}>
                <DocSvg />
                <Title title='Документы' />
              </div>
              <div className={styles.documents_info}>
                <a
                  className={styles.documents_info_doc}
                  href='https://skilla.ru/legal'
                  target='_blank'
                  rel='noreferrer'>
                  <PdfSvg />
                  <p>
                    {data?.beneficiary?.document?.name || 'Оферта'}{' '}
                    {data?.beneficiary?.document?.date
                      ? ` от ${data?.beneficiary?.document?.date}`
                      : ''}
                  </p>
                </a>
                <Button
                  onClick={() => {
                    setStartTimer(true);
                    setShowModalContract(true);
                  }}
                  icon
                  src={check}
                  className={styles.documents_info_btn}
                  theme='filed'>
                  Принять условия
                </Button>
              </div>
            </div>
          )}
          {!isSecurityPage ? (
            <>
              <div className={styles.main}>
                <Box visibleFrom='sm' w='100%'>
                  <div className={styles.main_info}>
                    <div className={styles.main_info_wrapper}>
                      <div
                        className={
                          screen ? styles.test : styles.main_info_company_wrapper
                        }>
                        <span className={styles.main_info_company}>
                          <TextWithTooltip
                            content={data?.customer.name}
                            className={styles.main_info_company}
                          />
                        </span>
                        {data?.customer && (
                          <CompanySelect
                            currentCompanyId={data?.id}
                            currentCompanyName={data?.customer?.name || ''}
                          />
                        )}
                      </div>
                      <div className={styles.main_info_details}>
                        {data?.customer.inn && <span>ИНН {data?.customer.inn}</span>}
                        {data?.customer.kpp && <span>КПП {data?.customer.kpp}</span>}
                        {data?.customer.ogrn && <span>ОГРН {data?.customer.ogrn}</span>}
                      </div>
                      {data?.customer.jur_address && (
                        <span className={styles.main_info_address}>
                          <TextWithTooltip
                            content={`Юр. адрес ${data?.customer.jur_address}`}
                            className={styles.main_info_address}
                          />
                        </span>
                      )}
                    </div>
                    <div className={styles.main_info_balance}>
                      {data?.beneficiary?.document?.is_added_to_bank ? (
                        <Balance />
                      ) : (
                        <div style={{ maxWidth: '280px' }}>
                          <InfoBlock title='Пополнение счета станет доступно после модерации заказчика площадкой' />
                        </div>
                      )}
                    </div>
                  </div>
                </Box>
                <Box hiddenFrom='sm' w='100%'>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      flexDirection: 'column',
                      gap: '8px',
                    }}>
                    {data?.customer && (
                      <CompanySelect
                        currentCompanyId={data?.id}
                        currentCompanyName={data?.customer?.name || ''}
                      />
                    )}
                    <span
                      className={styles.main_info_company}
                      style={{
                        color: '#121922',
                        fontSize: '20px',
                        fontWeight: 600,
                        lineHeight: '24px',
                      }}>
                      <TextWithTooltip
                        content={data?.customer.name}
                        className={styles.main_info_company}
                      />
                    </span>
                  </div>
                  <Box my='8px'>
                    <Balance />
                  </Box>
                  {showInfo ? (
                    <Box>
                      {data?.customer.inn && (
                        <p className={styles.info}>ИНН {data?.customer.inn}</p>
                      )}
                      {data?.customer.kpp && (
                        <p className={styles.info}>КПП {data?.customer.kpp}</p>
                      )}
                      {data?.customer.ogrn && (
                        <p className={styles.info}>ОГРН {data?.customer.ogrn}</p>
                      )}
                      {data?.customer.jur_address && (
                        <p className={styles.info}>
                          Юр. адрес {data?.customer.jur_address}
                        </p>
                      )}
                      <Anchor
                        mt='4px'
                        component='button'
                        fz='14'
                        c='#002CFB'
                        onClick={() => {
                          setShowInfo(false);
                        }}>
                        Скрыть
                      </Anchor>
                    </Box>
                  ) : (
                    <Anchor
                      component='button'
                      fz='14'
                      c='#002CFB'
                      onClick={() => {
                        setShowInfo(true);
                      }}>
                      Показать данные
                    </Anchor>
                  )}
                </Box>
                <div className={styles.main_data}>
                  {tabsData && <TabProfile tabsData={tabsData} openNav={openNav} />}
                </div>
              </div>
            </>
          ) : (
            <Security />
          )}
          {showModalProfile && (
            <ModalProfile
              showModalProfile={showModalProfile}
              title='ООО "Рога и Копыта"'
              ls='123456789'
              setShowModalProfile={setShowModalProfile}
              avatar=''
              sum='123'
            />
          )}
          {showModalContract && (
            <ModalContract
              startTimer={startTimer}
              setStartTimer={setStartTimer}
              timer={timer}
              setShowModalContract={setShowModalContract}
            />
          )}
          {showLogoutModal && (
            <ModalLogout
              showLogoutModal={showLogoutModal}
              setShowLogoutModal={setShowLogoutModal}
            />
          )}
        </>
      )}
    </Layout>
  );
};
